import { cn } from 'modules/v2/common/utils/cn';

import strings from '../../strings';
import { STATUS_CHIP_CLASSES } from '../../constants';

const StatusChip = ({ status }) => {
  const label = strings.statuses[status] || status;
  const classes = STATUS_CHIP_CLASSES[status] || 'bg-neutral-100 text-neutral-800';

  return (
    <span
      data-testid="mod-status-chip"
      className={cn('inline-block rounded-full px-3 py-1 text-xs font-semibold', classes)}
    >
      {label}
    </span>
  );
};

export default StatusChip;
